import { FirearmAssignmentLogItemComponentBase } from './firearm-assignment-log-item.component.base';
import { Component, ElementRef, Injector, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudEditorParentService, CrudEditorSelfService, UserStorage } from '@scisys-uim/uim-common';
import { FirearmAssignmentLogService, FirearmService, RefCodeStorage } from 'assets-service';

@Component({
  selector: 'app-firearm-assignment-log-item',
  templateUrl: './firearm-assignment-log-item.component.html',
  styleUrls: ['./firearm-assignment-log-item.component.scss'],
  providers: [CrudEditorParentService],
  viewProviders: [CrudEditorSelfService]
})
export class FirearmAssignmentLogItemComponent extends FirearmAssignmentLogItemComponentBase {

  constructor(protected firearmAssignmentLogService: FirearmAssignmentLogService,
    protected firearmService: FirearmService,
    protected refCodeStorage: RefCodeStorage,
    protected fb: FormBuilder,
    protected elementRef: ElementRef,
    protected router: Router,
    protected route: ActivatedRoute,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected injector: Injector,
    protected snackbar: MatSnackBar) {
    super(firearmAssignmentLogService, firearmService, refCodeStorage, fb, elementRef, router, route, userStorage, dialog, injector, snackbar);
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }

  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();
  }

  setDefaultDisabledFields() {
    if (!this.form) {
      return;
    }

    this.assetId?.disable();

    if (this.readOnly || !this.createMode) {
      this.firearm.disable();
    }
  }
    
  itemSet() {
    super.itemSet();
    this.firearmSelectionList = [this.item?.firearm]
  }
  
}





